import styled from 'styled-components';

export const StyledScriptData = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 4px;
`;
